import { render } from "./Experiment.vue?vue&type=template&id=62a3de64&bindings={\"title\":\"props\",\"description\":\"props\",\"label\":\"props\",\"year\":\"props\",\"items\":\"props\",\"isVisible\":\"data\",\"hasFullWidthComponent\":\"options\",\"isVideo\":\"options\"}"
import script from "./Experiment.vue?vue&type=script&lang=js"
export * from "./Experiment.vue?vue&type=script&lang=js"

import "./Experiment.vue?vue&type=style&index=0&lang=css"
script.render = render

export default script